import { Button, ToastMessage } from '@cokitchen/cokitchen-components';
import React, { FC, useState } from 'react';
import { ReactComponent as LogoutIcon } from 'assets/icons/error.svg';
import LocalModal from 'components/base/local-modal';
import { apiService } from 'services/base.service';
import { toast } from 'react-toastify';
import { handleApiError } from 'utils/functions';

interface ArchiveModalProps {
  show: boolean;
  onClose: () => void;
  vendorIds: string[];
  vendorName?: string;
  onSuccess: () => void;
}

interface ArchiveModalFooterProps {
  loading: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}

const ArchiveModalFooter: FC<ArchiveModalFooterProps> = ({ onCancel, onConfirm, loading }) => (
  <div className='flex gap-2 items-center justify-center'>
    <button className=' bg-[#F2F2F2] w-[139px] h-[41px] rounded-[100px] ' onClick={onCancel}>
      Cancel
    </button>
    <Button
      small
      color='primary'
      variant='block'
      className='w-[139px] h-[41px]'
      loading={loading}
      onClick={onConfirm}>
      Confirm
    </Button>
  </div>
);

const ArchiveModal: FC<ArchiveModalProps> = ({
  show,
  onClose,
  vendorIds,
  vendorName,
  onSuccess
}) => {
  const [loading, setLoading] = useState(false);

  const confirmArchive = async () => {
    try {
      setLoading(true);
      await apiService.put('vendors/archive', { version: 'v2', data: { vendor_ids: vendorIds } });
      toast(<ToastMessage message='Vendor(s) archived successfully' type='success' />);
      onSuccess();
      onClose();
    } catch (error) {
      handleApiError(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <LocalModal
      isOpen={show}
      title=''
      description={``}
      titleIconColor='danger'
      onRequestClose={() => onClose()}
      contentClassName='!max-w-[400px]'
      footer={
        <ArchiveModalFooter
          loading={loading}
          onCancel={() => onClose()}
          onConfirm={confirmArchive}
        />
      }>
      <div className='flex flex-col justify-center items-center pt-5'>
        <LogoutIcon />
        {vendorIds.length > 1 ? (
          <div>
            <p className='text-center pt-6 pb-3'>
              Are you sure you want to archive the selected vendors?
            </p>
            <p className='text-sm text-[#6F7376] text-center'>
              This will delete data associated with these vendors
            </p>
          </div>
        ) : (
          <div>
            <p className='text-[16px] font-medium py-2'>
              Are you sure you want to archive {vendorName}?
            </p>
            <p className='text-sm text-[#6F7376] text-center'>
              This will delete data associated with this vendor
            </p>
          </div>
        )}
      </div>
    </LocalModal>
  );
};

export default ArchiveModal;
